let base = 'https://d2wp3sepl8g4xv.cloudfront.net/live2d/';

export const expressionData = [
  {
    Name: 'smile',
    File: base + 'ANIM/smile.exp3.json',
  },
  {
    Name: 'smile2',
    File: base + 'ANIM/smile2.exp3.json',
  },
];

export const motionData_kobayashi = {
  Idle: [
    {
      File: 'https://faceless.hiho.jp/kobayashi/oh.motion3.json', //base + 'ANIM/idle.motion3.json',
    },
  ],
  Acting: [
    {
      File: base + 'ANIM/acting1.motion3.json',
    },
  ],
};

export const motionData = {
  Idle: [
    {
      File: base + 'ANIM/idle.motion3.json',
    },
  ],
  Acting: [
    {
      File: base + 'ANIM/acting1.motion3.json',
    },
    {
      File: base + 'ANIM/acting3.motion3.json',
    },
    {
      File: base + 'ANIM/acting4.motion3.json',
    },
    {
      File: base + 'ANIM/acting5.motion3.json',
    },
    {
      File: base + 'ANIM/acting6.motion3.json',
    },
    {
      File: base + 'ANIM/acting10.motion3.json',
    },
    {
      File: base + 'ANIM/acting11.motion3.json',
    },
    {
      File: base + 'ANIM/acting12.motion3.json',
    },
    {
      File: base + 'ANIM/acting13.motion3.json',
    },
    {
      File: base + 'ANIM/acting14.motion3.json',
    },
    {
      File: base + 'ANIM/acting15.motion3.json',
    },
    {
      File: base + 'ANIM/acting16.motion3.json',
    },

    {
      File: base + 'ANIM/acting20.motion3.json',
    },
    {
      File: base + 'ANIM/acting21.motion3.json',
    },
    {
      File: base + 'ANIM/acting22.motion3.json',
    },
    {
      File: base + 'ANIM/acting23.motion3.json',
    },
    {
      File: base + 'ANIM/acting24.motion3.json',
    },
    {
      File: base + 'ANIM/acting25.motion3.json',
    },
    {
      File: base + 'ANIM/acting26.motion3.json',
    },
    {
      File: base + 'ANIM/acting27.motion3.json',
    },
    {
      File: base + 'ANIM/acting28.motion3.json',
    },
  ],
};

//EyeBlinkの設定追加
// json.Groups = [
//   {
//     Target: 'Parameter',
//     Name: 'EyeBlink',
//     Ids: ['ParamEyeLOpen', 'ParamEyeROpen'],
//   },
// ];
